import { useDraggable, useDroppable } from '@dnd-kit/core';
import { observer } from 'mobx-react';
import { useMemo, useEffect, useState } from 'react';
import classNames from 'classnames';
import { dispatchingRulesStore } from '../../stores/dispatchingRulesStore';
import { Icons } from 'src/assets/fonts/Icons/icons';
import theme from 'src/constants/styles';
import { TBooleanInNumber } from 'src/types/main';
import { IDsp } from 'src/types/profiles';
import { booleanNumberReverse } from 'src/utils/helpers';
import Icon from 'src/view/components/Controls/Icon/Icon';
import Switcher from 'src/view/components/Controls/Switcher/Switcer';
import './style.scss';

interface IProps {
  dsp: IDsp;
  index: number;
  isOverlayDsp?: boolean;
  className?: string;
}

export const DspListItem = observer(({ dsp, index, isOverlayDsp, ...props }: IProps) => {
  const dspId = useMemo((): string => (isOverlayDsp ? '0' : String(dsp.id)), [dsp, isOverlayDsp]);
  const { attributes, isDragging, listeners, setNodeRef: draggableRef } = useDraggable({ id: dspId });
  const { isOver, setNodeRef: droppableRef } = useDroppable({ id: dspId });
  const [enabled, setEnabled] = useState<TBooleanInNumber>(dsp.enabled);

  useEffect(() => {
    if (dispatchingRulesStore.loading) return;
    setEnabled(dsp.enabled);
  }, [dsp.enabled, enabled]);

  const changeDspEnabled = async () => {
    await dispatchingRulesStore.updateProfile({ dspEnabled: { id: dsp.id } });
    setEnabled(booleanNumberReverse(enabled));
  };

  const className = useMemo((): string => {
    return classNames(
      'dsp-list-item ml-2',
      {
        'dsp-list-item__drag-clone': isDragging,
        'dsp-list-item__droppable': !isDragging && isOver,
      },
      props.className
    );
  }, [isDragging, isOver, props.className]);

  return (
    <li ref={isDragging ? draggableRef : droppableRef} className={className}>
      <p className="dsp-list-item__priority-number pl-2 mr-4">{index + 1}</p>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <div className="dsp-list-item__icon-wrapper py-1 pr-1 mr-2" {...listeners} {...attributes}>
        <Icon name={Icons.DragHand} size={14} color={theme.colors.gray2} className="dsp-list-item__icon" />
      </div>
      <Switcher status={enabled} onChange={changeDspEnabled} />
      <p className="dsp-list-item__name text-elipsis ml-4">{dsp.provider}</p>
      {isDragging ? <div className="pos-absolute full-width full-height" ref={droppableRef} /> : null}
    </li>
  );
});

// import { useSortable } from '@dnd-kit/sortable';
// import { CSS } from '@dnd-kit/utilities';

// interface IProps {
//   id: number;
//   name: string;
//   priorityNumber: number;
//   status: TBooleanInNumber;
//   activeId: string | null;
//   changeStatus: (id: number) => void;
// }

// export const DspListItem = (props: IProps) => {
//   const { attributes, isDragging, listeners, setNodeRef, transform, transition } = useSortable({ id: props.id.toString() });

//   const style = {
//     transform: CSS.Transform.toString(transform),
//     transition,
//   };

//   return (
//     <li
//       ref={setNodeRef}
//       style={style}
//       className={`dsp-list-item d-flex flex-row align-items-center ml-2 ${isDragging && 'dsp-list-item-drag_active'}`}
//     >
//       <p className="dsp-list-item__priority-number family-medium text-size-18 color-dark pl-2 mr-4">{props.priorityNumber}</p>
//       <div className="dsp-list-item__icon py-1 pr-1 mr-2" {...listeners} {...attributes}>
// <Icon name={Icons.ActiveOrders} size={14} color={theme.colors.gray2} />
//       </div>
//       <Switcher status={props.status} onChange={() => props.changeStatus(props.id)} />
//       <p className="family-medium text-size-18 color-dark ml-4">{props.name}</p>
//     </li>
//   );
// };
